import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./MobMain.css";
import MobProcess from "../../../Assets/Images/Technology/Mob/MobProcess.svg";
// import CrossPlat from "../../../Assets/Images/Technology/Mob/CrossPlatform.svg";
import CrossPlat from "../../../Assets/Images/Technology/Mob/CrossPlatform2.jpg";
import arrowIcon from "../../../Assets/Icons/arrow-right-icon.svg";
import example from "../../../Assets/Icons/Icon Wrapper.svg";

const MobMain = () => {
  return (
    <div className="mob-main">
      <div className="mob-content">
        <section className="mob-start">
          <p>
            Modern mobile apps are never constrained by ideas. They are
            constrained by the decisions about technology adopted at the
            beginning. At Quad Theory Ltd we choose mobile technologies based on
            how they work across devices, platforms, and real usage patterns,
            not just how fast they are to build with.
          </p>
        </section>
        {/* Java */}
        <div className="mob-section">
          <h2>
            <span className="span-1">Java —</span>{" "}
            <span className="span-2">The Backbone Of Android</span>
          </h2>
          <p>
            Java has long been the backbone of Android development for a reason.
            It is good at scale, complex logic and long-term maintenance,
            especially in apps that are more than just simple use cases.
          </p>
        </div>
        {/* React */}
        <div className="mob-section">
          <h2>
            <span className="span-1">React Native —</span>{" "}
            <span className="span-2">One Codebase, Multiple Platforms</span>
          </h2>
          <p>
            React Native provides us an opportunity to move faster without
            compromising on experience. By sharing logic across platforms, while
            trying to keep the performance close to native, it's a balance
            between speed and quality.
          </p>
        </div>
        {/* Swift */}
        <div className="mob-section">
          <h2>
            <span className="span-1">Swift —</span>{" "}
            <span className="span-2">Built for Apple's Ecosystem</span>
          </h2>
          <p>
            Swift is designed the way Apple wants Apps to behave. It is fast,
            safe and tightly integrated to iOS features, making it ideal for
            polished, high-performance Apple apps.
          </p>
        </div>
        {/* Xamarin */}
        <div className="mob-section">
          <h2>
            <span className="span-1">Xamarin —</span>{" "}
            <span className="span-2">Cross Platform With Structure</span>
          </h2>
          <p>
            Xamarin enables teams to develop cross-platform applications using
            C# and the .NET ecosystem. It is good when the shared logic,
            long-term maintainability and structured development are important.
          </p>
        </div>
        {/* Flutter */}
        <div className="mob-section">
          <h2>
            <span className="span-1">Flutter —</span>{" "}
            <span className="span-2">Performance With Consistency</span>
          </h2>
          <p>
            Flutter renders its own UI, allowing developers to have exact
            control over performance and visuals across platforms. It is useful
            especially when consistency and speed are equally important.
          </p>
        </div>
        {/* Cross Platform Image */}
        <div className="cross-plat-img">
          <div style={{ background: "#f5f5f5", borderRadius: "15px", padding: "3.2rem" }}>
            <div>
              <img src={CrossPlat} alt="CrossPlatform" className="img-fluid" />
            </div>
          </div>
        </div>
        {/* Approaches to Mobile App */}
        <div className="mob-section">
          <h2 className="Approach-title">
            Four Ways Mobile Apps Are Actually Built.
          </h2>
          <p>
            There is no universal formula for mobile app development. The right
            approach is dependent on performance needs and timelines, plus
            budget and how the app is expected to evolve. At Quad Theory Ltd, we
            assist teams in selecting the approach that is appropriate for their
            reality, and not just the trend of the moment.
          </p>
        </div>
        {/* Approach Image */}
        <div className="approach-img">
          <div style={{ background: "#f5f5f5", borderRadius: "15px" }}>
            <img src={MobProcess} alt="Mobile Process" className="" />
          </div>
        </div>
        {/* Native App Development */}
        <div className="mob-section">
          <h2 className="Approach-title">Native App Development</h2>
          <p>
            Native development is ideal when performance, hardware access, and
            platform-specific behaviour are of the most importance. Apps are
            inextricably embedded into the OS and feel entirely natural to the
            user.
          </p>
          <div className="example">
            <div className="example-st">
              <img src={example} alt="example" />
              <strong> Technologies and Languages</strong>{" "}
            </div>

            <ul>
              <li>
                <img src={arrowIcon} alt="" /> iOS development using Swift
              </li>
              <li>
                <img src={arrowIcon} alt="" /> Android development using Java
              </li>
            </ul>
          </div>
        </div>
        {/* Hybrid App Development */}
        <div className="mob-section">
          <h2 className="Approach-title">Hybrid App Development</h2>
          <p>
            Hybrid apps provide the option to build faster apps by integrating
            web technologies and a native container. They are good for
            content-heavy apps or internal apps where speed is more important
            than advanced native features.
          </p>
          <div className="example">
            <div className="example-st">
              <img src={example} alt="example" />
              <strong> Frameworks and Languages</strong>{" "}
            </div>

            <ul>
              <li>
                <img src={arrowIcon} alt="" /> Ionic framework
              </li>
              <li>
                <img src={arrowIcon} alt="" /> HTML
              </li>
              <li>
                <img src={arrowIcon} alt="" /> CSS
              </li>
              <li>
                <img src={arrowIcon} alt="" /> JavScript
              </li>
              <li>
                <img src={arrowIcon} alt="" /> TypeScript
              </li>
            </ul>
          </div>
        </div>
        {/* Cross-Platform App Development */}
        <div className="mob-section">
          <h2 className="Approach-title">Cross-Platform App Development</h2>
          <p>
            Cross-platform development is a compromise between speed and
            performance, as a single codebase can be used to power both iOS and
            Android apps. It is better to use when consistency and faster
            iteration is priority.
          </p>
          <div className="example">
            <div className="example-st">
              <img src={example} alt="example" />
              <strong> Frameworks and Languages</strong>{" "}
            </div>

            <ul>
              <li>
                <img src={arrowIcon} alt="" /> React Native with JavaScript or
                TypeScript
              </li>
              <li>
                <img src={arrowIcon} alt="" /> Xamarin with .NET and C#
              </li>
            </ul>
          </div>
        </div>
        {/* Progressive App Development */}
        <div className="mob-section">
          <h2 className="Approach-title">Progressive Web App Development</h2>
          <p>
            Progressive Web Apps are like mobile apps but they run on the web.
            They are lightweight, installable and ideal when reach and
            accessibility is more important than native integration that goes
            deep.
          </p>
          <div className="example">
            <div className="example-st">
              <img src={example} alt="example" />
              <strong> Technologies and Frameworks</strong>{" "}
            </div>

            <ul>
              <li>
                <img src={arrowIcon} alt="" /> HTML
              </li>
              <li>
                <img src={arrowIcon} alt="" /> CSS
              </li>
              <li>
                <img src={arrowIcon} alt="" /> JavaScript
              </li>
              <li>
                <img src={arrowIcon} alt="" /> React for building dynamic
                interfaces
              </li>
            </ul>
          </div>
        </div>
        {/* Quad Theory App Approach */}
        <div className="mob-section">
          <h2 className="Approach-title">
            How We Choose Mobile Technology Differently
          </h2>
          <p>
            Most mobile apps fail because the technology was selected too early.
            We take the opposite route. At Quad Theory Ltd, we first look at
            user behaviour, device constraints, update frequency and long-term
            maintenance. Only then do we decide whether native, cross-platform,
            hybrid or PWA makes sense. This avoids costly rewrites later on, and
            keeps the mobile app reliable as features, users, and operating
            systems change.
          </p>
        </div>
      </div>
    </div>
  );
};

export default MobMain;
